import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Redirect, Route, RouteComponentProps } from 'react-router-dom';
import './index.css';
import { RoomEditor } from './components/drawing/editor/FloorplanEditor';
import reportWebVitals from './reportWebVitals';
import { Home } from './Home';
import { initializeIcons } from '@fluentui/react';
import { PrivacyPolicy } from './components/policies/PrivacyPolicy';
import { CheckIn } from './components/checkin';

const Editor = (props: RouteComponentProps<{ floorplanId: string, layoutId: string }>) => {
    const { params } = props.match;
    const layoutId = parseInt(params.layoutId, 10);
    return React.createElement(
        RoomEditor,
        {
            ...props,
            floorplanId: params.floorplanId as string,
            layoutId: layoutId
        }
    );
};

initializeIcons();

const baseUrlStr = process.env.REACT_APP_BASEURL || "/";
const baseUrl = new URL(baseUrlStr);
export let basePath = baseUrl.pathname;
if (basePath.endsWith('/')) basePath = basePath.substring(0, basePath.lastIndexOf('/'));

ReactDOM.render(
    React.createElement(
        React.StrictMode,
        null,
        React.createElement(
            BrowserRouter,
            { basename: basePath },
            React.createElement(
                Route,
                { path: "/", exact: true },
                React.createElement(Redirect, { to: "/menu" })
            ),
            React.createElement(Route, { path: "/menu", component: Home }),
            React.createElement(
                Route,
                { path: "/privacy" },
                React.createElement(PrivacyPolicy, null)
            ),
            React.createElement(Route, {
                path: "/admin/layoutEditor/floorplan/:floorplanId/:layoutId",
                exact: true,
                component: Editor
            }),
            React.createElement(Route, {
                path: "/check-in/:siteId/:locationId/:roomId",
                exact: true,
                component: (route: RouteComponentProps<{ siteId: string; locationId: string; roomId: string }>) =>
                    React.createElement(CheckIn, { ...route.match.params })
            })
        )
    ),
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
